'use strict';
var inputElements = document.querySelectorAll('form input');
var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
try {
    for(var _iterator = inputElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
        var element = _step.value;
        var inputName = element.name;
        var capitalizedName = inputName[0].toUpperCase() + inputName.slice(1);
        element.placeholder = capitalizedName;
        var label = document.createElement('label');
        label.classList.add('field-label');
        label.htmlFor = element.id;
        label.textContent = capitalizedName;
        element.parentElement.insertBefore(label, element);
    }
} catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
} finally{
    try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
        }
    } finally{
        if (_didIteratorError) {
            throw _iteratorError;
        }
    }
}

//# sourceMappingURL=js_task_fix_form_DOM.63448c9e.js.map
